import { combineReducers } from "redux";
// import storage from 'redux-persist/lib/storage';
import storageSession from 'redux-persist/lib/storage/session'

import { addSuperAssetCommentErrorReducer, addSuperAssetCommentLoadingReducer,
		addAssetCommentErrorReducer, addAssetCommentLoadingReducer,
		assetCommentsErrorReducer, assetCommentsLoadingReducer, assetCommentsReducer,
		assetCountErrorReducer, assetCountLoadingReducer, assetCountReducer,
		assetConditionInfoErrorReducer, assetConditionInfoLoadingReducer, assetConditionInfoReducer,
		assetDetailsErrorReducer, assetDetailsLoadingReducer, assetDetailsReducer,
		assetDownloadMeasurementDataErrorReducer, assetDownloadMeasurementDataLoadingReducer,
		assetGraphCurrentDataReducer, assetGraphHistoricalDataReducer, assetGraphErrorReducer, assetGraphLoadingReducer,
		assetListErrorReducer, assetListLoadingReducer, assetListReducer,
		centerDateTimeListErrorReducer, centerDateTimeListLoadingReducer, centerDateTimeListReducer,
		fetchFaultEnumErrorReducer, fetchFaultEnumLoadingReducer, fetchFaultEnumReducer,
		metricListErrorReducer, metricListLoadingReducer, metricListReducer,
		plotlyGraphAndTableJsonErrorReducer, plotlyGraphAndTableJsonLoadingReducer, plotlyGraphAndTableJsonReducer,
		quickFeedbackDataReducer, quickFeedbackErrorReducer, quickFeedbackLoadingReducer,
		replaceSensorErrorReducer, replaceSensorLoadingReducer,
		superAssetCommentsReducer, superAssetCommentsErrorReducer, superAssetCommentsLoadingReducer,
		superAssetDetailsReducer, superAssetDetailsLoadingReducer, superAssetDetailsErrorReducer,
		updateMoteStatusErrorReducer, updateMoteStatusLoadingReducer,
		updateCustAssetTagErrorReducer, updateCustAssetTagLoadingReducer,
		superAssetImagesReducer, superAssetImagesErrorReducer, superAssetImagesLoadingReducer,
		assetImagesReducer, assetImagesErrorReducer, assetImagesLoadingReducer,
		fetchUnattachedSensorListReducer, fetchUnattachedSensorListLoadingReducer, fetchUnattachedSensorListErrorReducer,
		updateSensorInfoErrorReducer, updateSensorInfoLoadingReducer,
		detachSensorLoadingReducer, detachSensorErrorReducer,
		saveImageRotationErrorReducer, saveImageRotationLoadingReducer,
		deleteAssetImageErrorReducer, deleteAssetImageLoadingReducer,
		deleteSuperAssetImageErrorReducer, deleteSuperAssetImageLoadingReducer,
		fetchFeedbackTagsErrorReducer, fetchFeedbackTagsReducer, fetchFeedbackTagsLoadingReducer,
		downloadFeedbackFilesErrorReducer, downloadFeedbackFilesLoadingReducer,
		updateAlternateIdErrorReducer, updateAlternateIdLoadingReducer, addSensorLoadingReducer, getProgramIdListReducer,
		getProgramIdLoadingReducer, addSensorErrorReducer, feedbackAssetDetailsReducer, feedbackAssetDetailsErrorReducer, feedbackAssetDetailsLoadingReducer} from "./assetReducer";
import { customerListErrorReducer, customerListLoadingReducer, customerListReducer } from "./customerReducer";
import { addFeedCommentErrorReducer, addFeedCommentLoadingReducer,
		addUserFeedReducer, addUserFeedErrorReducer, addUserFeedLoadingReducer,
		feedCommentErrorReducer, feedCommentLoadingReducer, feedCommentReducer,
		feedFollowOrUnfollowErrorReducer, feedFollowOrUnfollowLoadingReducer,
		assetFeedListReducer, feedListErrorReducer, feedListLoadingReducer, feedListReducer,
		refreshFeedListErrorReducer, refreshFeedListLoadingReducer,
		feedsLastUpdatedDateTimeReducer, newFeedListReducer, newFeedsCountReducer } from "./feedReducer";
import { changePasswordDataReducer, changePasswordErrorReducer, changePasswordLoadingReducer,
		forgotPasswordDataReducer, forgotPasswordErrorReducer, forgotPasswordLoadingReducer,
		loginDataReducer, loginErrorReducer, loginLoadingReducer, loginReducer,
		updateUserLicenseAgreementStatusErrorReducer, updateUserLicenseAgreementStatusLoadingReducer,
		feedbackTokenVerificationSuccessReducer, feedbackTokenVerificationLoadingReducer, feedbackTokenVerificationErrorReducer } from "./loginReducer";
import { appCommonReducer, commonReducer } from "./reducer";
import { exportSensorListErrorReducer, exportSensorListLoadingReducer,
		sensorListErrorReducer, sensorListLoadingReducer, sensorListReducer,
		sensorHistoryForAnAssetErrorReducer, sensorHistoryForAnAssetLoadingReducer, sensorHistoryForAnAssetReducer,
		updateSensorUnresponsiveReasonErrorReducer, updateSensorUnresponsiveReasonLoadingReducer,
		sensorUnresponsiveReasonListErrorReducer, sensorUnresponsiveReasonListLoadingReducer, sensorUnresponsiveReasonListReducer } from "./sensorReducer";
import { addTicketCommentErrorReducer, addTicketCommentLoadingReducer,
		addTicketFeedbackErrorReducer, addTicketFeedbackLoadingReducer, addTicketFeedbackReducer,
		assignUserToTicketErrorReducer, assignUserToTicketLoadingReducer,
		createTicketByUserFeedOrAssetFeedReducer, createTicketByUserFeedOrAssetFeedErrorReducer, createTicketByUserFeedOrAssetFeedLoadingReducer,
		feedbackHistoryErrorReducer, feedbackHistoryLoadingReducer, feedbackHistoryReducer,
		ticketCloseOrReopenErrorReducer, ticketCloseOrReopenLoadingReducer, ticketCloseOrReopenReducer,
		ticketDetailsErrorReducer, ticketDetailsLoadingReducer, ticketDetailsReducer, feedbackFileReducer } from "./ticketReducer";
import { userDetailsErrorReducer, userDetailsLoadingReducer, userDetailsReducer, userListErrorReducer, userListLoadingReducer, userListReducer } from "./userReducer";
import { oilTestReportFilesReducer, oilTestReportFilesErrorReducer, oilTestReportFilesLoadingReducer,
		uploadOilTestReportDataReducer, uploadOilTestReportErrorReducer, uploadOilTestReportLoadingReducer } from "./reportReducer";

const rootReducer = (state, action) =>
{
	if (action.type == 'LOGOUT')
	{
		storageSession.removeItem(`persist:root`);

		state = undefined;
		return appReducer(undefined, action);
	}
	return appReducer(state, action);
}

const appReducer = combineReducers
({
	appCommonReducer,
	commonReducer,

	changePasswordDataReducer,
	changePasswordErrorReducer,
	changePasswordLoadingReducer,

	forgotPasswordDataReducer,
	forgotPasswordErrorReducer,
	forgotPasswordLoadingReducer,

	loginDataReducer,
	loginErrorReducer,
	loginLoadingReducer,
	loginReducer,

	updateUserLicenseAgreementStatusErrorReducer,
	updateUserLicenseAgreementStatusLoadingReducer,

	addSuperAssetCommentErrorReducer,
	addSuperAssetCommentLoadingReducer,

	assetCommentsErrorReducer,
	assetCommentsLoadingReducer,
	assetCommentsReducer,

	addAssetCommentErrorReducer,
	addAssetCommentLoadingReducer,

	assetCountErrorReducer,
	assetCountLoadingReducer,
	assetCountReducer,

	assetConditionInfoErrorReducer,
	assetConditionInfoLoadingReducer,
	assetConditionInfoReducer,

	assetDetailsErrorReducer,
	assetDetailsLoadingReducer,
	assetDetailsReducer,

	assetDownloadMeasurementDataErrorReducer,
	assetDownloadMeasurementDataLoadingReducer,

	assetGraphCurrentDataReducer,
	assetGraphHistoricalDataReducer,
	assetGraphErrorReducer,
	assetGraphLoadingReducer,

	assetListErrorReducer,
	assetListLoadingReducer,
	assetListReducer,

	centerDateTimeListErrorReducer,
	centerDateTimeListLoadingReducer,
	centerDateTimeListReducer,

	exportSensorListErrorReducer,
	exportSensorListLoadingReducer,

	fetchFaultEnumErrorReducer,
	fetchFaultEnumLoadingReducer,
	fetchFaultEnumReducer,

	metricListErrorReducer,
	metricListLoadingReducer,
	metricListReducer,

	plotlyGraphAndTableJsonErrorReducer,
	plotlyGraphAndTableJsonLoadingReducer,
	plotlyGraphAndTableJsonReducer,
	
	quickFeedbackDataReducer,
	quickFeedbackErrorReducer,
	quickFeedbackLoadingReducer,

	superAssetCommentsReducer,
	superAssetCommentsErrorReducer,
	superAssetCommentsLoadingReducer,

	superAssetDetailsReducer,
	superAssetDetailsLoadingReducer,
	superAssetDetailsErrorReducer,

	updateMoteStatusErrorReducer,
	updateMoteStatusLoadingReducer,

	updateCustAssetTagErrorReducer,
	updateCustAssetTagLoadingReducer,

	customerListErrorReducer,
	customerListLoadingReducer,
	customerListReducer,

	addFeedCommentErrorReducer,
	addFeedCommentLoadingReducer,
	
	feedCommentErrorReducer,
	feedCommentLoadingReducer,
	feedCommentReducer,
	
	feedFollowOrUnfollowErrorReducer,
	feedFollowOrUnfollowLoadingReducer,
	assetFeedListReducer,
	feedListErrorReducer,
	feedListLoadingReducer,
	feedListReducer,

	refreshFeedListErrorReducer,
	refreshFeedListLoadingReducer,
	feedsLastUpdatedDateTimeReducer,
	newFeedListReducer,
	newFeedsCountReducer,

	addUserFeedReducer,
	addUserFeedErrorReducer,
	addUserFeedLoadingReducer,

	addTicketCommentErrorReducer,
	addTicketCommentLoadingReducer,
	
	addTicketFeedbackErrorReducer,
	addTicketFeedbackLoadingReducer,
	addTicketFeedbackReducer,

	assignUserToTicketErrorReducer,
	assignUserToTicketLoadingReducer,

	createTicketByUserFeedOrAssetFeedReducer,
	createTicketByUserFeedOrAssetFeedErrorReducer,
	createTicketByUserFeedOrAssetFeedLoadingReducer,
	
	feedbackHistoryErrorReducer,
	feedbackHistoryLoadingReducer,
	feedbackHistoryReducer,

	replaceSensorErrorReducer,
	replaceSensorLoadingReducer,
	addSensorLoadingReducer,
	addSensorErrorReducer,

	sensorListErrorReducer,
	sensorListLoadingReducer,
	sensorListReducer,

	sensorHistoryForAnAssetErrorReducer,
	sensorHistoryForAnAssetLoadingReducer,
	sensorHistoryForAnAssetReducer,

	updateSensorUnresponsiveReasonErrorReducer,
	updateSensorUnresponsiveReasonLoadingReducer,

	sensorUnresponsiveReasonListErrorReducer,
	sensorUnresponsiveReasonListLoadingReducer,
	sensorUnresponsiveReasonListReducer,

	ticketCloseOrReopenErrorReducer,
	ticketCloseOrReopenLoadingReducer,
	ticketCloseOrReopenReducer,

	ticketDetailsErrorReducer,
	ticketDetailsLoadingReducer,
	ticketDetailsReducer,
	feedbackFileReducer,

	userDetailsErrorReducer,
	userDetailsLoadingReducer,
	userDetailsReducer,
	userListErrorReducer,
	userListLoadingReducer,
	userListReducer,

	superAssetImagesReducer,
	superAssetImagesErrorReducer,
	superAssetImagesLoadingReducer,

	assetImagesReducer,
	assetImagesErrorReducer,
	assetImagesLoadingReducer,
	
	fetchUnattachedSensorListReducer,
	fetchUnattachedSensorListLoadingReducer,
	fetchUnattachedSensorListErrorReducer,

	updateSensorInfoErrorReducer,
	updateSensorInfoLoadingReducer,

	detachSensorLoadingReducer,
	detachSensorErrorReducer,

	saveImageRotationErrorReducer,
	saveImageRotationLoadingReducer,

	deleteAssetImageErrorReducer,
	deleteAssetImageLoadingReducer,

	deleteSuperAssetImageErrorReducer,
	deleteSuperAssetImageLoadingReducer,
	
	fetchFeedbackTagsReducer,
	fetchFeedbackTagsErrorReducer,
	fetchFeedbackTagsLoadingReducer,
	
	downloadFeedbackFilesErrorReducer,
	downloadFeedbackFilesLoadingReducer,
	
	getProgramIdListReducer,
	getProgramIdLoadingReducer,
	
	updateAlternateIdErrorReducer,
	updateAlternateIdLoadingReducer,
	
	feedbackTokenVerificationSuccessReducer,
	feedbackTokenVerificationLoadingReducer,
	feedbackTokenVerificationErrorReducer,

	feedbackAssetDetailsReducer,
	feedbackAssetDetailsErrorReducer,
	feedbackAssetDetailsLoadingReducer,

	oilTestReportFilesReducer,
	oilTestReportFilesErrorReducer,
	oilTestReportFilesLoadingReducer,
	uploadOilTestReportDataReducer,
	uploadOilTestReportErrorReducer,
	uploadOilTestReportLoadingReducer
});

export default rootReducer;
